import { useMemo } from 'react';

import { createInterpolatedTranslationKey, Translate } from '@dreryk/react-common';
import {
   AlignItems,
   createDynamicColumnsWidth,
   InteractiveTableColumnConfiguration,
   JustifyContent,
   Text,
} from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../translations';
import {
   CONFIDENTIALITY_ACCESS_DURATION_MAX_HOURS,
   CONFIDENTIALITY_ACCESS_DURATION_MIN_HOURS,
} from '../ConfidentialitySettings.types';

import { AccessDurationCell } from './cells/AccessDurationCell';
import { ConfidentialityEditModalRow } from './ConfidentialityEditModal.types';

const t = generalSettingsTranslationKeys.confidentialitySettings;

export const useConfidentialityEditModalColumns = (): InteractiveTableColumnConfiguration<ConfidentialityEditModalRow>[] => {
   return useMemo(() => {
      const rangeValidationMessage = createInterpolatedTranslationKey(t.modal.validations.range, {
         min: CONFIDENTIALITY_ACCESS_DURATION_MIN_HOURS,
         max: CONFIDENTIALITY_ACCESS_DURATION_MAX_HOURS,
      });

      const columnWidths = createDynamicColumnsWidth({
         securityLevel: '100%',
         accessDuration: '120px',
      });

      return [
         {
            name: 'securityLevel',
            label: t.table.securityLevel,
            width: columnWidths.securityLevel,
            alignItems: AlignItems.CENTER,
            renderer: ({ bean }) => (
               <Text testId={`securityLevel-${bean.accessLevel}`}>
                  <Translate>{t.securityLevelMap[bean.accessLevel]}</Translate>
               </Text>
            ),
         },
         {
            name: 'accessDuration',
            label: t.table.accessDuration,
            width: columnWidths.accessDuration,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            renderer: ({ bean, index }) => (
               <AccessDurationCell
                  index={index}
                  defaultValue={bean.accessDurationHours}
                  rangeValidationMessage={rangeValidationMessage}
               />
            ),
         },
      ];
   }, []);
};
